import maplibregl from "maplibre-gl";

const NO_CAMERA_URL =
  "https://img.icons8.com/ios-filled/344/no-camera--v1.png";
const EVENT_IMAGE_NAMES = [
  "dash_center-image.jpeg",
  "forward_wide-image.jpeg",
];

const buildEventImageUrl = (bucket_name, vehicle, timestamp, imageName) =>
  `https://${bucket_name}.s3.eu-west-1.amazonaws.com/${vehicle}/${timestamp}/${imageName}`;

const buildEventImageTag = (bucket_name, vehicle, timestamp) => {
  const [primaryImage, fallbackImage] = EVENT_IMAGE_NAMES;
  const primaryUrl = buildEventImageUrl(
    bucket_name,
    vehicle,
    timestamp,
    primaryImage
  );
  const fallbackUrl = buildEventImageUrl(
    bucket_name,
    vehicle,
    timestamp,
    fallbackImage
  );

  return `<img src="${primaryUrl}" onerror="if(!this.dataset.triedFallback){this.dataset.triedFallback=1;this.src='${fallbackUrl}';}else{this.onerror=null;this.src='${NO_CAMERA_URL}';}" width="350" height="300"/>`;
};

const formatTimestamp = (timestamp) =>
  new Date(timestamp * 1000).toLocaleString("tr").replaceAll(".", "-");

const drawKeyEvents = (map, state, bucket_name) => {
  const isArray = Object.prototype.toString.call(state) === "[object Array]";

  if (!isArray) {
    new maplibregl.Marker({ color: "#EF6932" })
      .setLngLat([state.lng, state.lat])
      .setPopup(
        new maplibregl.Popup({ maxWidth: 350, closeButton: false }).setHTML(
          `<p>${formatTimestamp(state.timestamp)}</p>${buildEventImageTag(
            bucket_name,
            state.vehicle,
            state.timestamp
          )}`
        )
      )
      .addTo(map);
  } else {
    state.forEach(function (marker) {
      new maplibregl.Marker({ color: "#EF6932" })
        .setLngLat([marker.lng, marker.lat])
        .setPopup(
          new maplibregl.Popup({ maxWidth: 350, closeButton: false }).setHTML(
            `<p>${formatTimestamp(marker.timestamp)}</p>${buildEventImageTag(
              bucket_name,
              marker.vehicle,
              marker.timestamp
            )}`
          )
        )
        .addTo(map);
    });
  }
};

export default drawKeyEvents;
